// Packages:
import { NavLink, useRouteError } from "react-router-dom"

// Typescirpt
interface CustomErrorType  {
    message?: string
    status?: number
    statusText?: string
}

const NotFound = () => {
    // Constant:
    const error = useRouteError() as CustomErrorType
    return <div className='col-[2_/_3] h-screen flex justify-center items-center'>
        <div className=''>
            <h1 className='text-[40px] font-bold mb-[15px]'>{error?.message|| 'An unexpected error occurred!'}</h1>
            <p className='text-[18px]'>We're sorry, but an unexpected event has occurred.</p>
            <NavLink to='/' className='mt-[20px] w-max block font-bold text-[16px] rounded-[2rem] bg-[#FF6D28] text-[#F1F8FF] px-[24px] py-[12px]'>Go to Home</NavLink>
        </div>
    </div>
}

export default NotFound